import { saveToLocalStorage, loadFromLocalStorage } from './utils/localStorageUtils'
import { getDistanceFromLatLonInKm } from './utils/geomUtils'

let cities = []
let currentCity = null
let location = loadFromLocalStorage('location')

const timeZoneCities = {
  'Australia/Brisbane': [
    'Airlie Beach',
    'Brisbane',
    'Cairns',
    'Gold Coast',
    'Toowoomba',
    'Townsville',
    'Sunshine Coast',
    'Rockhampton',
    'Yatala',
  ],
  'Australia/Melbourne': ['Melbourne', 'Hobart', 'Geelong'],
  'Australia/Sydney': ['Sydney', 'Newcastle', 'Wollongong'],
  'Australia/Adelaide': ['Darwin', 'Adelaide'],
  'Australia/Perth': ['Perth'],
}

export function fetchAll() {
  return Promise.all([fetchWeatherOverview(), !location && fetchLocation()])
    .then(selectCityFromLocalStorage)
    .then(selectClosestCityIfRequired)
}

let $citiesXhr = null

function fetchWeatherOverview() {
  if (!$citiesXhr) {
    $citiesXhr = $.ajax('/toolbox/australia_overview.json', {
      dataType: 'json',
      success: (data) => {
        cities = data.data
      },
    })
  }
  return $citiesXhr
}

let $locationXhr = null

function fetchLocation() {
  if (!$locationXhr) {
    $locationXhr = $.ajax('/toolbox/get_location.json', {
      dataType: 'json',
      success: (data) => {
        location = data.location
        saveToLocalStorage('location', location)
      },
    })
  }
  return $locationXhr
}

function selectCityFromLocalStorage() {
  if (!currentCity) {
    const cityName = loadFromLocalStorage('city')
    if (cityName) setCurrentCity(cityName)
  }
}

function selectClosestCityIfRequired() {
  if (!currentCity && location) {
    const latLng = location.loc.split(',').map((num) => parseFloat(num))
    let closestCity = null
    let closestDistance = Number.MAX_SAFE_INTEGER
    cities.forEach((city) => {
      const distance = getDistanceFromLatLonInKm(latLng[0], latLng[1], city.coord.lat, city.coord.lon)
      if (distance < closestDistance) {
        closestDistance = distance
        closestCity = city
      }
    })
    currentCity = closestCity
  }
}

/**
 * @return string[]
 */
export function getCityNames() {
  return cities.map((city) => city.name)
}

export function getCurrentCityName() {
  return currentCity.name
}

export function getCurrentTimezone() {
  return getTimezoneFromCityString(currentCity.name)
}

export function getCurrentCity() {
  return currentCity
}

/**
 * @param {string} cityName
 */
export function setCurrentCity(cityName) {
  currentCity = cities.find((city) => cityName === city.name)
  saveToLocalStorage('city', cityName)
  $(document).trigger('cityChange')
}

export function getTemperatureString(temp_min, temp_max) {
  const tempMin = Math.round(temp_min * 10) / 10
  const tempMax = Math.round(temp_max * 10) / 10
  const tempRangeString = tempMin + '°C' + (tempMin != tempMax ? ' - ' + tempMax + '°C' : '')
  return tempRangeString
}

export function getPriority(code) {
  if (
    (code >= 200 && code <= 232) || // thunderstorms
    (code >= 502 && code <= 511) || // heavy rain
    [511, 522, 959].indexOf(code) >= 0 // intense rain
  )
    return 'warning'

  if (
    (code >= 600 && code <= 622) || // snow
    (code >= 900 && code <= 902) || // tornado, tropical storm, hurricane
    (code >= 960 && code <= 962) || // storm, violient storm, hurricane
    [906, 731, 751, 762, 781].indexOf(code) >= 0 // misc scary atmospheres
  )
    return 'alert'

  return 'fine'
}

/**
 * @param {string} cityName
 */
function getTimezoneFromCityString(cityName) {
  return Object.keys(timeZoneCities).reduce(
    (val, code) => (timeZoneCities[code].indexOf(cityName) >= 0 ? code : val),
    null
  )
}
